import { cn } from '../../utils/cn';

interface ShopChangelogPagePillProps {
  pageId: string;
  className?: string;
  onClick?: () => void;
}

/**
 * Small monospace pill for a shop page id (e.g. `create_numismatics`,
 * `global:ores`). Pages whose id starts with `global:` get a purple accent on
 * the prefix to make them stand out from per-cluster pages.
 */
export function ShopChangelogPagePill({ pageId, className, onClick }: ShopChangelogPagePillProps) {
  const colonIndex = pageId.indexOf(':');
  const hasNamespace = colonIndex > 0;
  const prefix = hasNamespace ? pageId.slice(0, colonIndex) : null;
  const rest = hasNamespace ? pageId.slice(colonIndex) : pageId;
  const isGlobal = prefix === 'global';

  const Wrapper: any = onClick ? 'button' : 'span';

  return (
    <Wrapper
      onClick={onClick}
      title={pageId}
      className={cn(
        'inline-flex items-center font-mono text-xs px-2 py-0.5 rounded-full',
        'bg-dark-900/40 border border-glass-200/30 text-glass-200',
        onClick && 'hover:border-accent-400/50 hover:text-white transition-colors cursor-pointer',
        className,
      )}
    >
      {hasNamespace ? (
        <>
          <span className={cn('font-semibold', isGlobal ? 'text-purple-300' : 'text-accent-300')}>{prefix}</span>
          <span>{rest}</span>
        </>
      ) : (
        <span>{rest}</span>
      )}
    </Wrapper>
  );
}
